module.exports = __webpack_public_path__ + "static/Calculator-a3f37a68d43f0e3a03093bc2f1b2776e.png";